var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.375 15C11.0674 15 13.25 12.8174 13.25 10.125C13.25 7.43261 11.0674 5.25 8.375 5.25C5.68261 5.25 3.5 7.43261 3.5 10.125C3.5 12.8174 5.68261 15 8.375 15Z",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45898 18.75C2.20813 17.5982 3.23311 16.6517 4.44086 15.9965C5.64861 15.3412 7.00089 14.998 8.37492 14.998C9.74896 14.998 11.1012 15.3412 12.309 15.9965C13.5167 16.6517 14.5417 17.5982 15.2909 18.75",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45898 18.75C2.20813 17.5982 3.23311 16.6517 4.44086 15.9965C5.64861 15.3412 7.00089 14.998 8.37492 14.998C9.74896 14.998 11.1012 15.3412 12.309 15.9965C13.5167 16.6517 14.5417 17.5982 15.2909 18.75",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 15C17.999 14.9992 19.3513 15.3418 20.5592 15.9967C21.767 16.6517 22.792 17.5981 23.5409 18.75",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 15C17.999 14.9992 19.3513 15.3418 20.5592 15.9967C21.767 16.6517 22.792 17.5981 23.5409 18.75",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8147 5.59687C15.4816 5.3309 16.1989 5.2155 16.9156 5.25893C17.6322 5.30235 18.3304 5.50352 18.9602 5.84806C19.5901 6.19261 20.1361 6.67202 20.5592 7.25204C20.9823 7.83206 21.2721 8.49838 21.4078 9.20338C21.5435 9.90837 21.5219 10.6346 21.3444 11.3303C21.1669 12.026 20.8379 12.6738 20.381 13.2276C19.9241 13.7814 19.3505 14.2274 18.7012 14.5338C18.0519 14.8402 17.343 14.9994 16.625 15",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8147 5.59687C15.4816 5.3309 16.1989 5.2155 16.9156 5.25893C17.6322 5.30235 18.3304 5.50352 18.9602 5.84806C19.5901 6.19261 20.1361 6.67202 20.5592 7.25204C20.9823 7.83206 21.2721 8.49838 21.4078 9.20338C21.5435 9.90837 21.5219 10.6346 21.3444 11.3303C21.1669 12.026 20.8379 12.6738 20.381 13.2276C19.9241 13.7814 19.3505 14.2274 18.7012 14.5338C18.0519 14.8402 17.343 14.9994 16.625 15",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.d44a4c561e8402e4020ef4b017ea1366.svg";
export { ForwardRef as ReactComponent };